<template>
  <div v-if="currentSelectedBay == null" ref="allBaysContainer">
    <button v-if="!isFullscreen" type="button" @click="ToggleFullScreen"
      class="btn btn-outline-primary font-weight-bold btn-sm mr-2">
      <i class="fas fa-expand"></i>
      <span class="hideButtonTitle"></span>
    </button>
    <v-row class="mb-1">
      <div class="flex my-2">
        <div class="ml-2" v-if="isFullscreen">
          <b-button @click="ToggleFullScreen" class="ml-2" size="sm" variant="outline-dark">
            <i class="fas fa-arrow-left mr-1"></i> {{ vesselMonitoringData.voyageName }}
          </b-button>
        </div>
        <div class="container-icons">
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class='' style='border: solid black 1px; gap: 4px;'>
              <svg width="20px" height="20px" viewbox="0 0 20 20" style="font-family: Arial, sans-serif">
                <path fill-opacity="0" stroke="#000000" stroke-width="1" d="M1,10 10,1 19,10 10,19 1,10"
                  class="white-stroke"></path>
              </svg>
            </div>
            <span>Hazardous</span>
          </div>
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class=''
              style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
              <span>e</span>
            </div>
            <span>Empty</span>
          </div>
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class=''
              style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
              <span>r</span>
            </div>
            <span>Reefer</span>
          </div>
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class=''
              style='border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
              <svg width="20px" height="20px" viewbox="0 0 20 20" style="font-family: Arial, sans-serif">
                <path transform="translate(10, -3)" fill="#000" stroke-width="0" d="M0,8 5,3 10,8"></path>
              </svg>
            </div>
            <span>High-cube</span>
          </div>
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class=''
              style='position: relative; border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
              <svg style='position: absolute; top: 0; left: 0;' width="20px" height="20px" viewbox="0 0 20 20">
                <path fill="#000" stroke-width="0" d="M0,0 9,0 9,3 0,3 0,0"></path>
              </svg>
            </div>
            <span>40-footer</span>
          </div>
          <div style='display: flex; justify-content: center; gap: 3px; align-items: center;'>
            <div class=''
              style='position: relative; border: solid black 1px; height: 24px; width: 24px; gap: 4px; display: flex; justify-content: center; align-items: center;'>
              <svg width="20px" height="20px" viewbox="0 0 20 20" style='position: absolute; top: 0; left: 0;'>
                <path fill="#000" stroke-width="0" d="M0,0 9,0 A 9 9, 0, 0, 1, 0 9 L0,0 Z"></path>
              </svg>
            </div>
            <span>45-footer</span>
          </div>
          <!-- Add more container property icons as needed -->
        </div>
      </div>
    </v-row>
    <div class="d-flex flex-row flex-wrap !flex-row-reverse" style="flex-direction: row-reverse !important;">
      <v-col v-if="!isFullscreen" v-for="(vesselHatch, index) in vesselMonitoringData?.vesselHatches"
        :key="`all-monitoring-bay-${index}`" :cols="cols">
        <vessel-monitoring-hatch :cellWidth="cellWidth" style="border: 1px #dfdfdf solid;" :vesselHatch='vesselHatch'
          :minDeckTiersNo="vesselMonitoringData?.minDeckTierNo" :maxRows="vesselMonitoringData?.maxRow"
          :minHoldTiersNo="vesselMonitoringData?.minHoldTierNo" />
      </v-col>

      <div v-if="isFullscreen" v-for="(vesselHatch, index) in vesselMonitoringData?.vesselHatches"
        :key="`all-monitoring-bay-${index}`">
        <vessel-monitoring-full-screen-hatch @selectedBay="selectedBay" :cellWidth="cellWidth"
          :style="(vesselHatch?.vesselBays?.length == 0) ? { width: '2px', background: 'black', height: '100%' } : { border: '1px #dfdfdf solid', borderBottom: '2px solid black' }"
          :vesselHatch='vesselHatch' :minDeckTiersNo="vesselMonitoringData?.minDeckTierNo"
          :maxRows="vesselMonitoringData?.maxRow" :minHoldTiersNo="vesselMonitoringData?.minHoldTierNo" />
      </div>
    </div>
  </div>
 <div v-else>
    <b-button @click="BackToMainFullScreen" class="ml-2" size="sm" variant="outline-dark">
      <i class="fas fa-arrow-left mr-1"></i> {{ vesselMonitoringData.voyageName }}
    </b-button>
    <v-col v-if="currentSelectedBay.typeView == 'singleBay'" cols="12" sm="12" md="12" lg="12">
      <vessel-monitoring-single-full-hatch :vesselBay="currentSelectedBay"
        :BayNo="currentSelectedBay?.vesselBays[0].bay"
        :vesselHatch="currentSelectedBay"></vessel-monitoring-single-full-hatch>
    </v-col>
    <div v-if="currentSelectedBay.typeView == 'simpleFullBay'" cols="12" sm="12" md="12" lg="12">
      <VesselMonitoringFullBay :name="currentSelectedBay?.vesselBays[0].bay" :cellWidth="30"
        :minDeckTiersNo="vesselMonitoringData?.minDeckTiersNo" :maxRows="vesselMonitoringData?.maxRow"
        :minHoldTiersNo="vesselMonitoringData?.minHoldTiersNo" :vesselHatch="currentSelectedBay"
        :vesselBay="currentSelectedBay?.vesselBays[0]"></VesselMonitoringFullBay>
    </div>
    <div v-if="currentSelectedBay.typeView == 'FullHatch'">
      <vessel-monitoring-single-full-hatch :vesselBay="currentSelectedBay"
        :BayNo="currentSelectedBay?.vesselBays[0].bay"
        :vesselHatch="currentSelectedBay"></vessel-monitoring-single-full-hatch>
      <vessel-monitoring-single-full-hatch :vesselBay="currentSelectedBay"
        :BayNo="currentSelectedBay?.vesselBays[1].bay"
        :vesselHatch="currentSelectedBay"></vessel-monitoring-single-full-hatch>
    </div>
    <div v-if="currentSelectedBay.typeView == 'simpleFullHatch'">
      <VesselMonitoringSimpleFullHatch :cellWidth="25" :minDeckTiersNo="vesselMonitoringData?.minDeckTiersNo"
        :maxRows="vesselMonitoringData?.maxRow" :minHoldTiersNo="vesselMonitoringData?.minHoldTiersNo"
        :vesselHatch="currentSelectedBay" :vesselBay="currentSelectedBay"></VesselMonitoringSimpleFullHatch>
    </div>
  </div>
</template>

<script>
import VesselMonitoringBay from '@/view/pages/vesselMonitoring/components/VesselMonitoringBay/VesselMonitoringBay.vue'
import VesselMonitoringHatch from '../VesselMonitoringBay/VesselMonitoringHatch.vue';
import { mapGetters, mapActions } from "vuex";
import SingleBayView from '../SingleBayView/SingleBayView.vue'
import VesselMonitoringSingleFullHatch from '../SingleBayView/VesselMonitoringSingleFullHatch.vue'
import VesselMonitoringFullScreenHatch from '../FullScreenHatchsView/VesselMonitoringHatch.vue'
import VesselMonitoringFullBay from '../FullScreenHatchsView/VesselMonitoringFullBay.vue'
import VesselMonitoringSimpleFullHatch from '../FullScreenHatchsView/VesselMonitoringSimpleFullHatch.vue'

export default {
  components: {
    VesselMonitoringBay,
    VesselMonitoringHatch,
    SingleBayView,
    VesselMonitoringSingleFullHatch,
    VesselMonitoringSimpleFullHatch,
    VesselMonitoringFullScreenHatch,
    VesselMonitoringFullBay
  },
  data() {
    return {
      Print: false,
      cellWidth: 20,
      isFullscreen: false,
      cols: 4,
      currentSelectedBay: null
    };
  },
  computed: {
    ...mapGetters(["getVesselMonitoringData","getShowWeightLevelChekbox"]),
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    },
      ShowWeightLevelCheckBox: {
      get() {
        return this.getShowWeightLevelChekbox;
      },
      set(value) {
        this.setShowWeightLevelChekbox(value);
      },
    },    
  },
  methods: {
    ...mapActions([
      "setShowWeightLevelChekbox",
    ]),
    BackToMainFullScreen() {
      this.currentSelectedBay = null
      this.setShowWeightLevelChekbox(true)
    },
    selectedBay(value) {
      this.currentSelectedBay = value
    },
    updateCellWidth() {
      const hatches = this.vesselMonitoringData?.vesselHatches || []
      let maxCols = 1
      let maxRows = 1
      hatches.forEach(hatch => {
        (hatch.vesselBays || []).forEach(bay => {
          if (bay.onDeck && bay.onDeck.cols) maxCols = Math.max(maxCols, bay.onDeck.cols)
          if (bay.hold && bay.hold.cols) maxCols = Math.max(maxCols, bay.hold.cols)
          if (bay.onDeck && bay.onDeck.rows) maxRows = Math.max(maxRows, bay.onDeck.rows)
          if (bay.hold && bay.hold.rows) maxRows = Math.max(maxRows, bay.hold.rows)
        })
      })

      const container = this.$refs.allBaysContainer
      const availableWidth = container ? container.clientWidth : window.innerWidth
      const availableHeight = container ? container.clientHeight : window.innerHeight

      let desired = Math.floor((availableWidth - 150) / Math.max(1, maxCols))
      desired = Math.max(6, Math.min(48, desired))

      const hatchesCount = Math.max(1, hatches.length)
      const totalHeightNeeded = hatchesCount * (maxRows * desired + 80)
      if (totalHeightNeeded > availableHeight) {
        const scale = availableHeight / totalHeightNeeded
        desired = Math.max(6, Math.floor(desired * scale))
      }
      this.cellWidth = 10;
    },
    ToggleFullScreen() {
      this.setShowWeightLevelChekbox(true)
      this.isFullscreen = !this.isFullscreen;
      window.parent.postMessage(this.isFullscreen ? "enterFullScreen" : "exitFullScreen", "*");
      if (!this.isFullscreen)
        this.currentSelectedBay = null
    },

    async tryEnterFullScreenOnLoad(data) {
      var data = JSON.parse(event.data);
      if (data && data.action == "enterFullScreen") {
        this.isFullscreen = true;
        this.cellWidth = this.vesselMonitoringData?.vesselHatches.length <= 24 ? 12 : 6;
        this.cols = 1;
      }
      else if (data && data.action == "exitFullScreen") {
        this.isFullscreen = false;
        this.cellWidth = 20;
        this.cols = 4;
        this.currentSelectedBay = null

      }
    }
  },
  mounted() {
    window.addEventListener("message", this.tryEnterFullScreenOnLoad);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.tryEnterFullScreenOnLoad);
  },
}
</script>

<style scoped>
.container-type-legend {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.container-type-legend v-badge {
  margin-right: 10px;
}

.container-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.container-icons v-icon {

  font-size: 18px;
  margin-right: 10px;
}

.container-type-legend v-badge[color="red"]::before {
  background-color: red;
}

.container-type-legend v-badge[color="grey"]::before {
  background-color: grey;
}

.container-type-legend v-badge[color="blue"]::before {
  background-color: blue;
}
</style>
